import React, { useState, useCallback } from "react";
import { FaCopy, FaCheck } from "react-icons/fa";
import { Button } from "ui-kit-takeat";
import {
  BrandCardContainer,
  BrandCardHeader,
  BrandCardFooter,
  BrandCardBody,
  BrandName,
  BrandSlug,
  BrandInfo,
  BadgesRow,
  Badge,
  ActionButtons,
  CopyIcon,
  NameWithCopy,
  BrandCardImage,
} from "./styles";

function BrandCard({ brand, onEdit, onDelete, onImport, onSetDefault }) {
  const [copiedField, setCopiedField] = useState(null);

  const formatCnpj = (cnpj) => {
    if (!cnpj) return null;
    const digits = cnpj.replace(/\D/g, "");
    if (digits.length !== 14) return cnpj;
    return digits.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
      "$1.$2.$3/$4-$5"
    );
  };

  const handleCopy = useCallback((field, value) => {
    navigator.clipboard.writeText(value);
    setCopiedField(field);
    setTimeout(() => setCopiedField(null), 1500);
  }, []);

  const imageUrl = brand.file?.url || null;

  return (
    <BrandCardContainer>
      <BrandCardBody>
        {imageUrl && (
          <BrandCardImage>
            <img src={imageUrl} alt={brand.fantasy_name} />
          </BrandCardImage>
        )}
        <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 8 }}>
          <BrandCardHeader>
            <NameWithCopy>
              <BrandName>{brand.fantasy_name}</BrandName>
              <CopyIcon onClick={() => handleCopy("fantasy_name", brand.fantasy_name)}>
                {copiedField === "fantasy_name" ? (
                  <FaCheck size={12} color="#28a745" />
                ) : (
                  <FaCopy size={12} />
                )}
              </CopyIcon>
            </NameWithCopy>
            <BadgesRow>
              {brand.is_default && <Badge color="#FFB32F">Padrão</Badge>}
              <Badge color={brand.is_active ? "#28a745" : "#6c757d"}>
                {brand.is_active ? "Ativa" : "Inativa"}
              </Badge>
            </BadgesRow>
          </BrandCardHeader>

          <NameWithCopy>
            <BrandSlug>{brand.name}</BrandSlug>
            <CopyIcon onClick={() => handleCopy("name", brand.name)}>
              {copiedField === "name" ? (
                <FaCheck size={11} color="#28a745" />
              ) : (
                <FaCopy size={11} />
              )}
            </CopyIcon>
          </NameWithCopy>

          {brand.cnpj && (
            <BrandInfo>CNPJ: {formatCnpj(brand.cnpj)}</BrandInfo>
          )}

          <BrandCardFooter>
            <div />
            <ActionButtons>
              <Button
                title="Importações"
                buttonColor="#17a2b8"
                onClick={() => onImport(brand)}
                containerStyles={{ height: 32 }}
              />
              <Button
                title="Editar"
                buttonColor="#007bff"
                onClick={() => onEdit(brand)}
                containerStyles={{ height: 32 }}
              />
              {!brand.is_default && (
                <Button
                  title="Tornar padrão"
                  buttonColor="#FFB32F"
                  onClick={() => onSetDefault(brand)}
                  containerStyles={{ height: 32 }}
                />
              )}
              {!brand.is_default && (
                <Button
                  title="Excluir"
                  buttonColor="#C8131B"
                  onClick={() => onDelete(brand)}
                  containerStyles={{ height: 32 }}
                />
              )}
            </ActionButtons>
          </BrandCardFooter>
        </div>
      </BrandCardBody>
    </BrandCardContainer>
  );
}

export default BrandCard;
